import { Swiper, Navigation} from "swiper/bundle";
export default class SwiperImageCarousel{
    constructor() {
        console.log('%c👍🏼 Image Carousel', 'color: yellow');     
        this.swiperImageCarousels = document.querySelectorAll('.swiper--image-carousel')
    }
    init() {

        this.swiperImageCarousels.forEach( swiperImageCarousel => {
            const nextButton = swiperImageCarousel.parentElement.querySelector('.swiper-button-next')
            const prevButton = swiperImageCarousel.parentElement.querySelector('.swiper-button-prev')
            new Swiper(swiperImageCarousel, {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 30,
                speed: 1001,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            });   
        });
        
    }
}